/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
import { colors } from "../../theme";

import { ReactComponent as Alert } from "../../assets/alert.svg";

const style = css`
    color: ${colors.error5};
    font-size: 15px;
    width: 100%;
    align-items: center;
    padding: 4px 0;
    svg {
        position: relative;
        top: 4px;
    }
    & > * {
        margin-right: 4px;
    }
`;

const ValidationError = ({ children, ...props }) => (
    <div className="validation-error" css={style} {...props}>
        <Alert />
        {children}
    </div>
);

export default ValidationError;
